import React, { useEffect, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import AppNavigation from './AppNavigation';
import supabase from '../utils/supabaseUtils';

const Layout = ({ children }) => {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const isEditor = location.pathname.includes('/editor');
  const [activeSection, setActiveSection] = useState('designs');

  // Fetch user data
  useEffect(() => {
    const getUserData = async () => {
      const { data } = await supabase.auth.getUser();
      if (data?.user) {
        setUser(data.user);
      }
    };
    
    getUserData();
  }, []);
  
  // Function to handle section change from AppNavigation
  const handleSectionChange = (section) => {
    setActiveSection(section);
    
    // Find if any child has a handleSectionChange method and pass it along
    if (children && React.isValidElement(children)) {
      const childProps = children.props;
      if (childProps && typeof childProps.onSectionChange === 'function') {
        childProps.onSectionChange(section);
      } else {
        // If the main child component doesn't have the function, 
        // try to expose the section through a global event for legacy components
        try {
          const event = new CustomEvent('section-change', { detail: { section } });
          document.dispatchEvent(event);
        } catch (e) {
          console.warn('Could not dispatch section change event', e);
        }
      }
    }
  };
  
  // Clone children to pass activeSection prop
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { 
        activeSection,
        setActiveSection
      });
    }
    return child;
  });

  return (
    <Flex h="100vh" bg="bg.primary">
      {/* App Navigation Component */}
      {user && <AppNavigation user={user} isEditor={isEditor} onSectionChange={handleSectionChange} />}

      {/* Main content */}
      <Box
        as="main"
        flex="1"
        ml={{ base: 0, md: isEditor ? 0 : '250px' }}
        pt={{ base: '64px', md: 0 }}
        transition="margin-left 0.3s"
        height="100vh"
        overflow="auto"
        width="auto"
      >
        {childrenWithProps}
      </Box>
    </Flex>
  );
};

export default Layout; 